import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Form, FormLayout, TextField, Button, PageActions } from '@shopify/polaris';

import { BasicTextField } from '@presentational';
import FormPageActions from '@container/FormPageActions';

import { tAttribute } from '@utils';

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};


const WarrantyForm = ({ handleChange, handleSubmit, values, errors, ...props }) => {
  let sharedFieldProps = {
    handleChange,
    values,
    errors
  }
  return(
    <Form onSubmit={handleSubmit}>
      <FormLayout>
        <hr />
        <BasicTextField 
          name="name"
          label={ tAttribute("warranty", "name") }
          {...sharedFieldProps}
        />
      
        <BasicTextField 
          name="tag"
          label={ tAttribute("warranty", "tag") }
          {...sharedFieldProps}
        />
      </FormLayout>

      <FormPageActions
        onPrimaryAction={ handleSubmit }
        deleteURL={ props.deleteURL }
      />
    </Form>
  )
}


WarrantyForm.propTypes = propTypes;


export default WarrantyForm;
